import axios from 'axios'
import { getToken } from '@/utils/storage'
let Index = {
  data() {
    return {
      groupTypeList: [], // 站点
      langList: [],
      isshowlogin: false, // 是否登录
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    // 操作成功提醒（success）
    $success(command,msg) {
      let message = {
        add: '添加成功!',
        upd: '修改成功!',
        del: '删除成功!',
        operation: 'Operation succeeded!',
        custom: msg,
      }
      this.$message.success(command && message[command] || 'Operation succeeded')
      return true
    },
    // 操作失败提醒（faild）
    $faild(command,msg) {
      let message = {
        add: 'Failed to add!',
        upd: 'Modification failed!',
        del: 'Delete failed!',
        operation: 'Operation failed!',
        custom: msg,

      }
      this.$message.error(command && message[command] || 'Operation failed')
      return true
    },
    $regNum(val){
      let startNum = val.lastIndexOf('/')
      let aa = val.substring(startNum+1, val.length)
      return aa
    },
    // 图片上传
    uploadImgFun (method,url,fileFormData) {
      // 选择原图之后
      return axios({
        method: method,
        url: url,
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          'Content-Type': 'multipart/form-data',
        },
        data: fileFormData
      }).then(resolve => {
        return Promise.resolve(resolve.data)
        // if (resolve.status == 200) {
        //   // this.$success('operation')
        //
        // } else {
        //   this.$faild('operation')
        // }
      })
    },
    // 登录框打开或者关闭
    changeLogin (data) {
      this.isshowlogin = data
    }
  }
};
export default Index;
